import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { videoActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { video } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setVideoList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentVideo = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionVideo = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const videoReducer = createReducer(video, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setVideoList,
  [actions.CURRENT]: setCurrentVideo,
  [actions.CUD]: actionVideo,
});
